/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  addClipResponse: null,
  saveClip: null
};

const reducer = (state = initialState, action = {}) => {
 
  switch (action.type) {
    case actions.AddVideoTrimAction.REQUEST_ADDVIDEOTRIM:
      return {
        ...state
      };
    case actions.AddVideoTrimAction.ADDVIDEOTRIM_RECEIVED:
      return {
        ...state,
        addClipResponse : action.data.response,
        saveClip: action.data.statusCode
      };
      case actions.AddVideoTrimAction.CLEAR_VIDEOTRIM:
        return {
          ...state,
          saveClip: 0
        };

    default:
      return state;
  }
};

export default reducer;
